/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  ChangeOfTenancyRequestDto,
  ChangeOfTenancyResponseDto,
  GetChangeOfTenancyMoveInConstraintsParams,
  MoveInConstraintsResponseDto,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Change of tenancy done by agent
 */
export const changeOfTenancy = (
  changeOfTenancyRequestDto: ChangeOfTenancyRequestDto,
  options?: SecondParameter<
    typeof backofficeRequest<ChangeOfTenancyResponseDto>
  >,
) => {
  return backofficeRequest<ChangeOfTenancyResponseDto>(
    {
      url: `/api/v1/change_of_tenancy`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: changeOfTenancyRequestDto,
    },
    options,
  )
}
/**
 * Server-owned bounds for the first day of responsibility (FDOR) of a new occupant moving into the given account's property: from max(the account's own floor, today minus COT_MOVE_IN_PAST_FDOR_MAX_WINDOW days) to today plus COT_MOVE_IN_FUTURE_FDOR_MAX_WINDOW days, both configurable server-side. The floor is the day after the previous occupant's account ended, else the account start - the same rule the customer portal uses for its candidate first day of responsibility. POST /api/v1/change_of_tenancy enforces the same window behind the change-of-tenancy stay-upfront feature flag and refuses a date outside it with 400 and errorCode cotFirstDayOfResponsibilityOutsideWindow. Bind the move-in date picker to this response rather than to a hardcoded range.
 * @summary Date bounds for an agent-driven move-in change of tenancy
 */
export const getChangeOfTenancyMoveInConstraints = (
  params: GetChangeOfTenancyMoveInConstraintsParams,
  options?: SecondParameter<
    typeof backofficeRequest<MoveInConstraintsResponseDto>
  >,
) => {
  return backofficeRequest<MoveInConstraintsResponseDto>(
    {
      url: `/api/v1/change_of_tenancy/move_in/constraints`,
      method: "GET",
      params,
    },
    options,
  )
}
export type ChangeOfTenancyResult = NonNullable<
  Awaited<ReturnType<typeof changeOfTenancy>>
>
export type GetChangeOfTenancyMoveInConstraintsResult = NonNullable<
  Awaited<ReturnType<typeof getChangeOfTenancyMoveInConstraints>>
>
